<template>
  <component :is="getContainerType" :class="getClassName">
    <table>
      <tr>
        <th v-for="(colHeader, key) in getColHeaders" :key="key">
          {{ $t(colHeader) }}
        </th>
      </tr>
      <tr
        v-for="(qtyRow, key) in getQuantities"
        :key="key"
        :class="activeClass(qtyRow.active)"
        @click="getSetQuantityFunction(qtyRow.quantity, qtyRow.code)"
      >
        <td>{{ qtyRow.quantity }} {{ $t("Pcs") }}</td>
        <td v-if="canDisplayNetPrice()">
          {{
            qtyRow.formatted_base_price
              ? qtyRow.formatted_base_price
              : $n(qtyRow.base_price, "currency")
          }}
        </td>
        <td v-if="canDisplayGrossPrice()">
          {{
            qtyRow.formatted_gross_price
              ? qtyRow.formatted_gross_price
              : $n(qtyRow.gross_price, "currency")
          }}
        </td>
      </tr>
    </table>
  </component>
</template>
<script>
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

import constants from "../../helpers/constants";

function quantity_debounce(fn, delay) {
  var timeoutID = null;
  return function () {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

export default {
  computed: {
    ...mapState(useChangeOptionsStore, ["getQuantities", "getHasGrossPrice"]),
    ...mapState(useWebproductStore, ["getPriceDisplayType", "getEnableLoader"]),
    getColHeaders: function () {
      let headers = ["Quantity"];
      const priceDisplayType = this.getPriceDisplayType;
      if (
        constants.TAX_DISPLAY_TYPE_EXCL_TAX == priceDisplayType ||
        constants.TAX_DISPLAY_TYPE_BOTH == priceDisplayType
      ) {
        headers.push("Net");
      }
      if (
        constants.TAX_DISPLAY_TYPE_INCL_TAX == priceDisplayType ||
        constants.TAX_DISPLAY_TYPE_BOTH == priceDisplayType
      ) {
        headers.push("Gross");
      }
      return headers;
    },
    getSetQuantityFunction: function () {
      return this.getEnableLoader
        ? this.setQuantityNoDebounce
        : this.setQuantityDebounce;
    }
  },

  methods: {
    ...mapActions(useChangeOptionsStore, ["setQuantity", "setPageOption"]),
    setQuantityDebounce: quantity_debounce(function (qty, qtyCode) {
      this.setQuantity({ qty, qtyCode });
    }, 500),
    setQuantityNoDebounce: function (qty, qtyCode) {
      this.setQuantity({ qty, qtyCode });
    },
    activeClass: active => {
      return active ? "active" : "";
    },
    canDisplayNetPrice: function () {
      return (
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_EXCL_TAX ||
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_BOTH
      );
    },
    canDisplayGrossPrice: function () {
      return (
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_INCL_TAX ||
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_BOTH
      );
    }
  },
  props: ["hideContainer"]
};
</script>
